import {
  selectAnalyticsProduct,
  selectAnalyticsExtraOfferIds,
} from '../../../../shared/ServicePickerWidget/selectors/analytics';
import { selectTotalAmount } from '../../../../shared/ServicePickerWidget/selectors/checkoutInfo';
import { selectServiceUnavailableReason } from '../../../../shared/ServicePickerWidget/selectors/publishTerms';
import { selectTotalBalance } from '../../../../shared/ServicePickerWidget/selectors/balance';
import { EUnavailableReason } from '../../../../shared/ServicePickerWidget/types/reducers/publishTerms';
import { IExtendedContext } from '../../../types/extendedContext';
import { trackPayByCardModalOpen } from './tracking';
import { openPaymentModalThunk } from '../../../../shared/ServicePickerWidget/thunks/payment/openPaymentModal';

// Метод временный, после реализации сервиса пополнения баланса будет удален
export const checkPublishAvailabilityHandler = (context: IExtendedContext) => () => {
  const { store } = context;

  const state = store.getState();

  const balance = Number(selectTotalBalance(state));
  const { price: total } = selectTotalAmount(state);

  const unavailableReason = selectServiceUnavailableReason(state);

  if (total > balance) {
    const amount = Math.ceil(total - balance);

    store.dispatch(openPaymentModalThunk(amount));

    trackPayByCardModalOpen({
      analyticsExtraOfferIds: selectAnalyticsExtraOfferIds(state),
      analyticsProduct: selectAnalyticsProduct(state),
    });

    return false;
  }

  if (unavailableReason === EUnavailableReason.noPhotos) {
    context.appEvent.onPublicationUnavailableReasonChange(EUnavailableReason.noPhotos);

    return false;
  }

  return true;
};
